import GerepAPI from './GerepAPI'

export default class SurveillanceService {

	static getStates() {
		return GerepAPI.get('/checkWsState', null)
	}
}
